module.exports = __webpack_public_path__ + "static/img/animation21.gif";